import { approverType } from "../../../../../constants";

export const getStepBaseOnApprover = (item: any, currentUserName: string) => {
  const { eApprovedBy, eApprovedByITLead, eApprovedByITHead, eAssignee } = item;
  const approverEmail = eApprovedBy ? eApprovedBy.split("|")[1] : "";
  const approvedByITLeadEmail = eApprovedByITLead
    ? eApprovedByITLead.split("|")[1]
    : "";
  const approvedByITHeadEmail = eApprovedByITHead
    ? eApprovedByITHead.split("|")[1]
    : "";
  const assigneeEmail = eAssignee ? eAssignee.split("|")[1] : "";
  if (currentUserName.toLowerCase() === approverEmail?.toLowerCase()) {
    return approverType.approver;
  } else if (
    currentUserName.toLowerCase() === approvedByITLeadEmail?.toLowerCase()
  ) {
    return approverType.itlead;
  } else if (
    currentUserName.toLowerCase() === approvedByITHeadEmail?.toLowerCase()
  ) {
    return approverType.ithead;
  } else if (currentUserName.toLowerCase() === assigneeEmail?.toLowerCase()) {
    return approverType.assignee;
  }
};
